/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TGetNewbuildingJsonQueryModel,
  IGetNewbuildingJsonQueryRequest,
  IMappers,
  IGetNewbuildingJsonQueryResponse,
  IGetNewbuildingJsonQueryResponseError,
  TGetNewbuildingJsonQueryResponse,
} from './types';

const defaultConfig: TGetNewbuildingJsonQueryModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'newbuilding-search',
  pathApi: '/v2/get-newbuilding-json-query/',
  hostType: 'api',
} as TGetNewbuildingJsonQueryModel;

function createGetNewbuildingJsonQueryModel(
  parameters: IGetNewbuildingJsonQueryRequest,
): TGetNewbuildingJsonQueryModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetNewbuildingJsonQueryOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetNewbuildingJsonQueryRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetNewbuildingJsonQuery<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetNewbuildingJsonQueryOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetNewbuildingJsonQueryResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetNewbuildingJsonQueryModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetNewbuildingJsonQueryResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetNewbuildingJsonQueryResponseError);
    }
  }

  return { response, statusCode } as TGetNewbuildingJsonQueryResponse;
}

export { defaultConfig, createGetNewbuildingJsonQueryModel, fetchGetNewbuildingJsonQuery };
